// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"bcf52a88","186":"1fcff02f","215":"22a70aae","372":"8cc462b6","630":"55c0675c","738":"232ac846","841":"989d56b5","851":"4c3e7453","856":"aa6ebc79"}[chunkId] + ".chunk.js";
};